var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9875 26.4888C20.1066 26.4888 25.9827 20.6127 25.9827 13.5061C25.9827 6.39955 20.094 0.523438 12.9749 0.523438C5.86832 0.523438 0.00476074 6.39955 0.00476074 13.5061C0.00476074 20.6127 5.88088 26.4888 12.9875 26.4888ZM8.70593 18.9805C8.04047 18.9805 7.51313 18.4531 7.51313 17.7751C7.51313 17.4738 7.63869 17.1724 7.87725 16.9464L11.2924 13.5187L7.87725 10.1035C7.63869 9.87751 7.51313 9.57617 7.51313 9.27483C7.51313 8.59682 8.04047 8.08203 8.70593 8.08203C9.05749 8.08203 9.33372 8.19503 9.55973 8.42104L12.9875 11.8362L16.4278 8.40848C16.6789 8.16992 16.9425 8.05692 17.2815 8.05692C17.947 8.05692 18.4743 8.58426 18.4743 9.24972C18.4743 9.56362 18.3488 9.83984 18.1102 10.091L14.6951 13.5187L18.1102 16.9339C18.3362 17.1724 18.4618 17.4612 18.4618 17.7751C18.4618 18.4531 17.9344 18.9805 17.2564 18.9805C16.9174 18.9805 16.6286 18.8549 16.3901 18.6289L12.9875 15.2263L9.58484 18.6289C9.35883 18.8675 9.05749 18.9805 8.70593 18.9805Z",
    fill: "#303030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpClose);
export default __webpack_public_path__ + "static/media/help-close.7a99af0a2d9f0231b5094181d239e30b.svg";
export { ForwardRef as ReactComponent };